import styled from 'styled-components';

import { BaseLandholdScreen } from '../../../../svg';

export const LandholdScreenImage = styled(BaseLandholdScreen)`
    height: 100%;
    max-height: 400px;
    width: auto;
    margin: 0 auto;
    padding: 20px;
`;
